import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import djangoIcon from '../../../assets/images/skills/django.svg';
import rubyIcon from '../../../assets/images/skills/ruby.svg';
import psIcon from '../../../assets/images/skills/ps.png';
import phpIcon from '../../../assets/images/skills/php.svg';
import mysqlIcon from '../../../assets/images/skills/mysql.svg';
import mongodbIcon from '../../../assets/images/skills/mongoDB.svg';
import postgresqlIcon from '../../../assets/images/skills/postgresql.svg';
import solidityIcon from '../../../assets/images/skills/solidity.png';
import smartcontractIcon from '../../../assets/images/skills/smartcontract.png';
import flutterIcon from '../../../assets/images/skills/flutter.png';

export const SkillItem = ({ icon, title, xp }) => {
	return (
		<div className='skill'>
			<i className='iconContainer'>
				{ icon === djangoIcon || icon === flutterIcon || icon === smartcontractIcon || icon === solidityIcon || icon === rubyIcon || icon === psIcon || icon === phpIcon || icon === mysqlIcon || icon === mongodbIcon || icon === postgresqlIcon ? (<img src={icon} alt=""/>) :
					(<FontAwesomeIcon icon={icon} />)
				}
 			</i>
			<div className='skillContent'>
				<p>{title}</p>
				<p>XP: {xp}</p>
			</div>
		</div>
	);
};
